import { render, staticRenderFns } from "./DealerPeakControl.vue?vue&type=template&id=6f68fd80&scoped=true"
import script from "./DealerPeakControl.vue?vue&type=script&lang=js"
export * from "./DealerPeakControl.vue?vue&type=script&lang=js"
import "./DealerPeakControl.vue?vue&type=style&index=0&id=6f68fd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68fd80",
  null
  
)

export default component.exports